export const getContactInformation = (contactInformation: string) => {
  if(contactInformation){
      const matches = contactInformation.match(/[+\d-]+|\bTHE-LOST\b/g);
      return matches ? matches.reduce((newContact, matchText) => {
        return newContact.replace(new RegExp(matchText.replace('+', '\\+'), 'g'), `<strong>${matchText}</strong>`)
      }, contactInformation) : contactInformation;
  }
  return contactInformation;
}